module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAgCAYAAAB6kdqOAAAAAXNSR0IArs4c6QAAATBJREFUWEft171KxEAUxfHfKIgIfoGtT2HlG/gCfhS6CIIgguU2dm7lOwiijSiioA+glZ3Y+Coq6uLIyKaUgWx2jZC0N/fc/5xM5iRBza6QeGKMHSxhBt0hM47iBU9ohxjjFo6GDPHbuMMEdIzNmgBdJqAF3GGyBlCrxR6aw3pvD/0F1ztuQwjPP0B1uhqg3NNoHGocyjmQq9dzD8UYD7CM8ZS1uVVUXE+mfOIR2yk6WjipeEhZuU4COsVGWYWK+64S0CLuMVaxeBm5VhGu80jfRbP4KqPUR88IXnvh+lDPt6yP1VXe2jiUs7Rx6P86FGNMP2wTuRUMqN4NIbwl7eJgbGMPUwMamJP9wDV2U3Ss4DzXMaT6fgI6w9qQBubG3BTheoHp3N0DrqcM3andOfQNRKhPvQ7EAz4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hamburger.png
// module id = 2THF
// module chunks = 26